import { isNil } from 'ramda';

interface ITestTypeStartedFunctionMap {
  measured: (test: any) => boolean;
  imported: (test: any) => boolean;
  autoImported: (test: any) => boolean;
  external: (test: any) => boolean;
}

/**
 * This map should not be defined in this file, but probably located with the tests themselves so the code is maintained
 * together.
 */
export const testTypeStartedFunctionMap: { [key: string]: ITestTypeStartedFunctionMap } = {
  'Moisture Content': {
    measured: (mc: any) => !!mc?.DryingTray?.WetSoilAndContainerMass,
    imported: () => true,
    autoImported: () => true,
    external: (externalTest: any) => !!externalTest.Results && !isNil(externalTest.Results.MoistureContentPercent),
  },
  'Moisture Correlation': {
    measured: () => true,
    imported: () => true,
    autoImported: () => true,
    external: (externalTest: any) =>
      !!externalTest.Results && !isNil(externalTest.Results.Slope) && !isNil(externalTest.Results.Intercept),
  },
  'Field Rock Correction': {
    measured: () => true,
    imported: () => false,
    autoImported: () => false,
    external: () => false,
  },
  'Oversize Determination': {
    measured: () => true,
    imported: () => true,
    autoImported: () => true,
    external: () => false,
  },
  'Specific Gravity Coarse': {
    measured: () => true, // TODO: Add specific condition here?
    imported: () => true,
    autoImported: () => true,
    external: (externalTest: any) =>
      !!externalTest.Results &&
      (externalTest.Results.Absorption ||
        externalTest.Results.SpecificGravityOvenDry ||
        externalTest.Results.SpecificGravitySSD ||
        externalTest.Results.ApparentSpecificGravity),
  },
  'Sieve Analysis': {
    measured: (psd: any) =>
      !!psd.BouldersPercentage ||
      !!psd.CobblesPercentage ||
      !!psd.GravelPercentage ||
      !!psd.SandPercentage ||
      !!psd.FinesPercentage,

    imported: () => true,
    autoImported: () => true,
    external: (externalTest: any) =>
      !!externalTest.Results &&
      (!!externalTest.Results.GravelPercentage ||
        !!externalTest.Results.SandPercentage ||
        !!externalTest.Results.FinesPercentage),
  },
  'Atterberg Limit': {
    measured: () => true,
    imported: () => true,
    autoImported: () => true,
    external: () => false,
  },
  'Liquid Limit': {
    measured: () => true,
    imported: () => true,
    autoImported: () => true,
    external: (externalTest: any) => !!externalTest.Results && externalTest.Results.LiquidLimit,
  },
  'Particle Density': {
    measured: () => true,
    imported: () => true,
    autoImported: () => true,
    external: (externalTest: any) => !!externalTest.Results && externalTest.Results.ParticleDensity,
  },
  Wash: {
    measured: () => true,
    imported: () => true,
    autoImported: () => true,
    external: () => false,
  },
  'Soil Classification': {
    measured: () => true,
    imported: () => true,
    autoImported: () => true,
    external: () => false,
  },
  'Maximum Dry Density': {
    measured: () => true,
    imported: () => true,
    autoImported: () => true,
    external: () => false,
  },
  'Nuclear Field Density': {
    measured: () => true,
    imported: () => true,
    autoImported: () => true,
    external: () => false,
  },
  'Linear Shrinkage': {
    measured: () => true,
    imported: () => true,
    autoImported: () => true,
    external: () => false,
  },
  'Binder Content': {
    measured: () => true,
    imported: () => true,
    autoImported: () => true,
    external: () => false,
  },
};
